import type { WebhookInboxStatus } from "@/types/webhook-inbox"

/**
 * Desfecho do processamento de cada webhook recebido, na paleta do portal:
 * emerald = processado, gray = ignorado de propósito, amber = ainda na fila,
 * red = falhou (EXHAUSTED estourou o teto de tentativas e não volta sozinho).
 */
/**
 * Estados oferecidos no filtro — só os desfechos sobre os quais o operador age.
 *
 * `RECEIVED` fica de fora por ser transitório: a linha nasce assim e sai desse estado quando o
 * consumer termina, então filtrar por ele devolve o que estiver na fila naquele instante.
 * `SKIPPED` também sai: significa "não havia o que processar", não é problema a investigar.
 *
 * Os dois continuam existindo e ganham badge normalmente na listagem — o que muda é só o que a
 * tela oferece como recorte.
 */
export const WEBHOOK_INBOX_FILTER_STATUSES: WebhookInboxStatus[] =
  ["PROCESSED", "FAILED", "EXHAUSTED"]

const STATUS_CLASSES: Record<WebhookInboxStatus, string> = {
  RECEIVED: "bg-amber-50 border-amber-200 text-amber-700",
  PROCESSED:
    "bg-emerald-50 border-emerald-200 text-emerald-700",
  SKIPPED: "bg-gray-50 border-gray-200 text-gray-700",
  FAILED: "bg-red-50 border-red-200 text-red-700",
  EXHAUSTED: "bg-red-50 border-red-200 text-red-700",
}

const FALLBACK_CLASSES =
  "bg-gray-50 border-gray-200 text-gray-700"

/** Classes do badge suave do status; valor desconhecido cai no neutro. */
export const getWebhookInboxStatusClasses = (
  status?: string
) =>
  STATUS_CLASSES[status as WebhookInboxStatus] ??
  FALLBACK_CLASSES

/** Só faz sentido reprocessar o que falhou ou ficou pendurado. */
export const isReprocessable = (status?: string) =>
  status === "FAILED" ||
  status === "EXHAUSTED" ||
  status === "RECEIVED"
